var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Award(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 8v33.22L45 50V8h6zm-4 52a9 9 0 11-17.999 0A9 9 0 0147 60zm-3.5 0a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM41 48.31V8h-6v40.31a11.45 11.45 0 016 0zm-3 9.19a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM31 8h-6v33.22L31 50V8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Award.ee88dcf8.svg";
export { SvgK1Award as ReactComponent };